import type { ViewModelEntity } from '@view-model/domain/view-model';
import type { Workspace } from '@workspace/domain/workspace';
import { Link } from 'react-router-dom';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiagramProject, faGlobe, faLock } from '@fortawesome/free-solid-svg-icons';
import { HighlightText } from './HighlightText';
import { classNames } from '@framework/utils';

type Props = {
  viewModel: ViewModelEntity;
  workspace: Workspace;
  searchKeyword?: string;
  isExternal?: boolean;
};

export const ViewModelItemTitle: React.FC<Props> = ({
  viewModel,
  workspace,
  searchKeyword,
  isExternal = false,
}: Props) => {
  return (
    <Link
      to={UserPagePathBuilder.viewModelPage(viewModel.id)}
      className={classNames('flex min-w-0 items-center rounded-sm py-1 pr-1')}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
        {viewModel.isPublicReadable(workspace.setting) ? (
          <>
            <FontAwesomeIcon icon={faDiagramProject} transform="shrink-2 top-3 left-1" />
            <FontAwesomeIcon icon={faGlobe} transform="shrink-8 down-3 right-7" />
          </>
        ) : (
          <FontAwesomeIcon icon={faDiagramProject} />
        )}
      </span>
      {viewModel.isLocked && (
        <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
          <FontAwesomeIcon icon={faLock} />
        </span>
      )}
      <HighlightText className="truncate" text={viewModel.name.toString()} keyword={searchKeyword || ''} />
    </Link>
  );
};
